import { render } from "./CreateLimitLocationMaxCapForm.vue?vue&type=template&id=55f282a5"
import script from "./CreateLimitLocationMaxCapForm.vue?vue&type=script&lang=js"
export * from "./CreateLimitLocationMaxCapForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__